import React from "react"
import { Badge } from "../ui/badge"
import { pluralize } from "../../utils/pluralize"
import { ServiceTypes } from "../../data/service-types"
import { SvgUsersSolid, SvgClock } from "../icons"

interface Props {
  service: any
}

const ServicePageBadges: React.FC<Props> = ({ service }) => {
  let Icon: React.ElementType | null = null
  let title = ""
  let description = ""

  if (service?.service_details) {
    const { type, isGroupService } = service.service_details
    const serviceType = ServiceTypes[type]

    if (serviceType) {
      Icon = serviceType.Icon
      title = serviceType.title
      description = serviceType.description
    }

    if (isGroupService) {
      Icon = SvgUsersSolid
      title = "Group Session"
      description =
        "This is a group coaching program where multiple clients can join and participate together."
    }
  }

  const getSessionCount = () => {
    const count = service?.service_details?.session?.count
    const type = service?.service_details?.type

    if (["consultation", "individual"].includes(type)) return `${count} session`
    if (["bundle"].includes(type)) return pluralize(count, "session")
    if (["recurring"].includes(type))
      return (
        <div>
          {pluralize(count, "session")}
          <span className="text-darkGray">
            {" "}
            / {service?.service_details?.billing?.unit}
          </span>
        </div>
      )
    return "Not Found"
  }

  const getLengthOrExpiration = () => {
    const type = service?.service_details?.type

    if (["consultation", "individual", "bundle"].includes(type)) {
      if (service?.service_details?.expiration?.expires) {
        return `Expires after ${service?.service_details?.expiration?.time} ${service?.service_details?.expiration?.type}`
      }
      return ""
    } else if (type === "recurring") {
      const units =
        service?.service_details?.expiration?.type === "weeks"
          ? "week"
          : "month"
      return `${service?.service_details?.expiration?.time} ${units} program`
    }

    return ""
  }

  return (
    <div className="flex flex-wrap gap-x-2 gap-y-2">
      <Badge variant="secondary" className="flex items-center h-8">
        {Icon && <Icon className="mr-1 w-4 h-4" />}
        {title}
      </Badge>
      <Badge variant="secondary" className="flex items-center h-8">
        {parseInt(service?.service_details?.session?.duration) / 60} minutes
      </Badge>

      {service.is_group_service === true && (
        <>
          <Badge variant="secondary" className="flex items-center h-8">
            {getSessionCount()}
          </Badge>

          {getLengthOrExpiration() && (
            <Badge variant="secondary" className="flex items-center h-8">
              {getLengthOrExpiration()}
            </Badge>
          )}
        </>
      )}

      {(service.availability_status === "inactive" ||
        service.is_group_service === true) && (
        <Badge variant="secondary" className="flex items-center h-8">
          <SvgClock className="shrink-0 w-4 h-4" />
          <span className="ml-2 text-base">Scheduling managed by coach</span>
        </Badge>
      )}
    </div>
  )
}

export default ServicePageBadges
